import React, { useState } from 'react';

const Page = ({children})=>{

	const [ modal, setModal ] = useState(null);

	return <div className="full-page">
		<div className="norm">
			<div className="header">
				<img src={`${process.env.PUBLIC_URL}/logo.svg`} alt="Jumbletree Logo"/>
				Jumbletree LEARN
			</div>
			{React.Children.map(children, child=>React.cloneElement(child, {setModal}))}
		</div>
		<div className="overlay" style={{display: modal === null ? "none" : "block"}} />
		<div className="modal-overlay" style={{display: modal === null ? "none" : "flex"}}>
			<div className="modal-outer">
				<div className="modal-content">
					{modal===null ? null : React.cloneElement(modal, {closeModal: ()=>setModal(null)})}
				</div>
			</div>
		</div>
	</div>;

}

export default Page;